import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const App = defineMessages({
  title: { id: 'app.containers.App.title' },
});

export const Notifications = defineMessages({
  actionFailed: { id: 'app.notifications.actionFailed' },
  'too-many-points': { id: 'app.notifications.too-many-points' },

  // TODO: migrate gradually to the new message ID format: app.notifications.<entity>.<action>.<status>
  emissionFactorCreateSuccess: { id: 'app.notifications.emissionFactorCreateSuccess' },
  emissionFactorCreateError: { id: 'app.notifications.emissionFactorCreateError' },
  emissionFactorDeleteSuccess: { id: 'app.notifications.emissionFactorDeleteSuccess' },
  emissionFactorDeleteError: { id: 'app.notifications.emissionFactorDeleteError' },
  emissionFactorEditSuccess: { id: 'app.notifications.emissionFactorEditSuccess' },
  emissionFactorEditError: { id: 'app.notifications.emissionFactorEditError' },
  createManualRecordSuccess: { id: 'app.notifications.createManualRecordSuccess' },
  createManualRecordError: { id: 'app.notifications.createManualRecordError' },
  createRecordError: { id: 'app.notifications.createRecordError' },
  createRecordSuccess: { id: 'app.notifications.createRecordSuccess' },
  createSupplyPointError: { id: 'app.notifications.createSupplyPointError' },
  createSupplyPointSuccess: { id: 'app.notifications.createSupplyPointSuccess' },
  createSupplyPointValidationError: { id: 'app.notifications.createSupplyPointValidationError' },
  dashboardLoadError: {
    id: 'app.notifications.dashboardLoadError',
  },
  dashboardUserSuggestionAcknowledgmentSuccess: {
    id: 'app.notifications.dashboardUserSuggestionAcknowledgmentSuccess',
  },
  dashboardUserSuggestionAcknowledgmentError: { id: 'app.notifications.dashboardUserSuggestionAcknowledgmentError' },
  deleteFileError: { id: 'app.notifications.deleteFileError' },
  deleteFileSuccess: { id: 'app.notifications.deleteFileSuccess' },
  deleteManualRecordSuccess: { id: 'app.notifications.deleteManualRecordSuccess' },
  deleteManualRecordError: { id: 'app.notifications.deleteManualRecordError' },
  deleteRecordError: { id: 'app.notifications.deleteRecordError' },
  deleteRecordSuccess: { id: 'app.notifications.deleteRecordSuccess' },
  deleteRecordsError: { id: 'app.notifications.deleteRecordsError' },
  deleteRecordsSuccess: { id: 'app.notifications.deleteRecordsSuccess' },
  deleteSupplyPointError: { id: 'app.notifications.deleteSupplyPointError' },
  deleteSupplyPointSuccess: { id: 'app.notifications.deleteSupplyPointSuccess' },
  updateSupplyPointError: { id: 'app.notifications.updateSupplyPointError' },
  updateSupplyPointSuccess: { id: 'app.notifications.updateSupplyPointSuccess' },
  editRecordError: { id: 'app.notifications.editRecordError' },
  editRecordSuccess: { id: 'app.notifications.editRecordSuccess' },
  emissionRecordCreateSuccess: { id: 'app.notifications.emissionRecordCreateSuccess' },
  emissionRecordDeleteSuccess: { id: 'app.notifications.emissionRecordDeleteSuccess' },
  emissionRecordEditSuccess: { id: 'app.notifications.emissionRecordEditSuccess' },
  exportCreateError: { id: 'app.notifications.exportCreateError' },
  exportSectionLink: { id: 'app.notifications.exportSectionLink' },
  exportCreateSuccess: { id: 'app.notifications.exportCreateSuccess' },
  exportDataReady: { id: 'app.notifications.exportDataReady' },
  exportDeleteSuccess: { id: 'app.notifications.exportDeleteSuccess' },
  exportDeleteError: { id: 'app.notifications.exportDeleteError' },
  exportEditSuccess: { id: 'app.notifications.exportEditSuccess' },
  exportEditError: { id: 'app.notifications.exportEditError' },
  exportForceRunSuccess: { id: 'app.notifications.exportForceRunSuccess' },
  exportForceRunError: { id: 'app.notifications.exportForceRunError' },
  exportSendingPaused: { id: 'app.notifications.exportSendingPaused' },
  exportSendingPausedError: { id: 'app.notifications.exportSendingPausedError' },
  exportSendingResumed: { id: 'app.notifications.exportSendingResumed' },
  exportSendingResumedError: { id: 'app.notifications.exportSendingResumedError' },
  forceResetPasswordSuccess: { id: 'app.notifications.forceResetPasswordSuccess' },
  getSupplyPointsMetadataError: { id: 'app.notifications.getSupplyPointsMetadataError' },
  loadAnalysisError: { id: 'app.notifications.loadAnalysisError' },
  loadRecordsError: { id: 'app.notifications.loadRecordsError' },
  moveSupplyPointError: { id: 'app.notifications.moveSupplyPointError' },
  moveSupplyPointSuccess: { id: 'app.notifications.moveSupplyPointSuccess' },
  moveSupplyPointFailed: { id: 'app.notifications.moveSupplyPointFailed' },
  moveSupplyPointSingleSuccess: { id: 'app.notifications.moveSupplyPointSingleSuccess' },
  moveSupplyPointSingleError: { id: 'app.notifications.moveSupplyPointSingleError' },
  suspendSupplyPointsSuccess: { id: 'app.notifications.suspendSupplyPointsSuccess' },
  suspendSupplyPointsFailed: { id: 'app.notifications.suspendSupplyPointsFailed' },
  suspendSupplyPointsError: { id: 'app.notifications.suspendSupplyPointsError' },
  toggleSupplyPointStatusSuccess: { id: 'app.notifications.toggleSupplyPointStatusSuccess' },
  toggleSupplyPointStatusError: { id: 'app.notifications.toggleSupplyPointStatusError' },
  bulkChangeSuccess: { id: 'app.notifications.bulkChangeSuccess' },
  bulkChangeFailed: { id: 'app.notifications.bulkChangeFailed' },
  bulkChangeError: { id: 'app.notifications.bulkChangeError' },
  saveNotificationSettingFailed: { id: 'app.notifications.saveNotificationSettingFailed' },
  saveNotificationSettingSucceeded: { id: 'app.notifications.saveNotificationSettingSucceeded' },
  notificationResolved: { id: 'app.notifications.notificationResolved' },
  notificationReturnedToUnresolved: { id: 'app.notifications.notificationReturnedToUnresolved' },
  notificationReturnedToList: { id: 'app.notifications.notificationReturnedToList' },
  notificationArchived: { id: 'app.notifications.notificationArchived' },
  notificationMuted: { id: 'app.notifications.notificationMuted' },
  notificationUnmuted: { id: 'app.notifications.notificationUnmuted' },
  notificationSettingsArchived: { id: 'app.notifications.notificationSettingsArchived' },
  notificationSettingsRestored: { id: 'app.notifications.notificationSettingsRestored' },
  notificationSettingsSuspended: { id: 'app.notifications.notificationSettingsSuspended' },
  notificationSettingsActivated: { id: 'app.notifications.notificationSettingsActivated' },
  notificationSettingsChangesSaved: { id: 'app.notifications.notificationSettingsChangesSaved' },

  updateManualRecordSuccess: { id: 'app.notifications.updateManualRecordSuccess' },
  updateManualRecordError: { id: 'app.notifications.updateManualRecordError' },
  uploadFileError: { id: 'app.notifications.uploadFileError' },
  unsupportedFileError: { id: 'app.notifications.unsupportedFileError' },
  uploadFileSuccess: { id: 'app.notifications.uploadFileSuccess' },
  uploadFilesError: { id: 'app.notifications.uploadFilesError' },
  uploadFilesSuccess: { id: 'app.notifications.uploadFilesSuccess' },
  editFileSuccess: { id: 'app.notifications.editFileSuccess' },
  editFileError: { id: 'app.notifications.editFileError' },
  downloadFileError: { id: 'app.notifications.downloadFileError' },
  fileLimitError: { id: 'app.notifications.fileLimitError' },
  fileValidationError: { id: 'app.notifications.fileValidationError' },
  deleteValiditySuccess: { id: 'app.notifications.deleteValiditySuccess' },
  deleteValidityError: { id: 'app.notifications.deleteValidityError' },
  createValiditySuccess: { id: 'app.notifications.createValiditySuccess' },
  createValidityError: { id: 'app.notifications.createValidityError' },
  // end of TODO comment

  // Authentication
  changePasswordSuccess: { id: 'app.notifications.password.change.success' },
  resetPasswordSuccess: { id: 'app.notifications.password.reset.success' },
  resetPasswordError: { id: 'app.notifications.password.reset.error' },
  setPasswordSuccess: { id: 'app.notifications.password.set.success' },
  loginSuccess: { id: 'app.notifications.authentication.login.success' },
  logoutSuccess: { id: 'app.notifications.authentication.logout.success' },
  logoutError: { id: 'app.notifications.authentication.logout.error' },
  loginToCustomerError: { id: 'app.notifications.authentication.loginToCustomer.error' },
  logoutFromCustomerError: { id: 'app.notifications.authentication.logoutFromCustomer.error' },
  otpSuccess: { id: 'app.notifications.otp.verify.success' },
  twoFactorDisableError: { id: 'app.notifications.twoFactor.disable.error' },
  twoFactorDisableSuccess: { id: 'app.notifications.twoFactor.disable.success' },
  twoFactorVerifyTotpSuccess: { id: 'app.notifications.twoFactor.verifyTotp.success' },
  twoFactorVerifyBackupCodeSuccess: { id: 'app.notifications.twoFactor.verifyBackupCode.success' },

  // FORMATTED NOTIFICATION MESSAGES
  fetchingDataFailed: { id: 'app.notifications.fetchingDataFailed' },

  // User
  createUserSuccess: { id: 'app.notifications.user.create.success' },
  createUserError: { id: 'app.notifications.user.create.error' },
  editUserSuccess: { id: 'app.notifications.user.edit.success' },
  editUserError: { id: 'app.notifications.user.edit.error' },
  editUserSettingsSuccess: { id: 'app.notifications.userSettings.edit.success' },
  editUserSettingsError: { id: 'app.notifications.userSettings.edit.error' },
  deleteUserSuccess: { id: 'app.notifications.user.delete.success' },
  deleteUserError: { id: 'app.notifications.user.delete.error' },
  deleteUsersBulkSuccess: { id: 'app.notifications.user.deleteBulk.success' },
  deleteUsersBulkFailed: { id: 'app.notifications.user.deleteBulk.failed' },
  deleteUsersBulkError: { id: 'app.notifications.user.deleteBulk.error' },
  updateUsersPermissionsBulkSuccess: { id: 'app.notifications.user.updatePermissionsBulk.success' },
  updateUsersPermissionsBulkFailed: { id: 'app.notifications.user.updatePermissionsBulk.failed' },
  updateUsersPermissionsBulkError: { id: 'app.notifications.user.updatePermissionsBulk.error' },
  updateUsersAccessesBulkSuccess: { id: 'app.notifications.user.updateAccessesBulk.success' },
  updateUsersAccessesBulkFailed: { id: 'app.notifications.user.updateAccessesBulk.failed' },
  updateUsersAccessesBulkError: { id: 'app.notifications.user.updateAccessesBulk.error' },
  resetUsersPasswordBulkSuccess: { id: 'app.notifications.user.resetPasswordBulk.success' },
  resetUsersPasswordBulkFailed: { id: 'app.notifications.user.resetPasswordBulk.failed' },
  resetUsersPasswordBulkError: { id: 'app.notifications.user.resetPasswordBulk.error' },

  // User onboarding bubble tour
  changeStepBubbleTourError: { id: 'app.notifications.bubbleTour.changeStep.error' },

  // Establishments
  createEstablishmentSuccess: { id: 'app.notifications.establishment.create.success' },
  createEstablishmentError: { id: 'app.notifications.establishment.create.error' },
  importEstablishmentSuccess: { id: 'app.notifications.establishment.import.success' },
  importEstablishmentError: { id: 'app.notifications.establishment.import.error' },
  editEstablishmentSuccess: { id: 'app.notifications.establishment.edit.success' },
  editEstablishmentError: { id: 'app.notifications.establishment.edit.error' },
  deleteEstablishmentSuccess: { id: 'app.notifications.establishment.delete.success' },
  deleteEstablishmentError: { id: 'app.notifications.establishment.delete.error' },
  bulkAddTagsEstablishmentSuccess: { id: 'app.notifications.establishment.bulkAddTags.success' },
  bulkAddTagsEstablishmentFailed: { id: 'app.notifications.establishment.bulkAddTags.failed' },
  bulkAddTagsEstablishmentError: { id: 'app.notifications.establishment.bulkAddTags.error' },
  bulkRemoveTagsEstablishmentSuccess: { id: 'app.notifications.establishment.bulkRemoveTags.success' },
  bulkRemoveTagsEstablishmentFailed: { id: 'app.notifications.establishment.bulkRemoveTags.failed' },
  bulkRemoveTagsEstablishmentError: { id: 'app.notifications.establishment.bulkRemoveTags.error' },

  // Meter
  createMeterSuccess: { id: 'app.notifications.meter.create.success' },
  createMeterError: { id: 'app.notifications.meter.create.error' },
  editMeterSuccess: { id: 'app.notifications.meter.edit.success' },
  editMeterError: { id: 'app.notifications.meter.edit.error' },
  deleteMeterSuccess: { id: 'app.notifications.meter.delete.success' },
  deleteMeterError: { id: 'app.notifications.meter.delete.error' },
  moveMeterError: { id: 'app.notifications.meter.move.error' },
  moveMeterSuccess: { id: 'app.notifications.meter.move.success' },
  moveMetersBulkError: { id: 'app.notifications.meter.moveBulk.error' },
  moveMetersBulkSuccess: { id: 'app.notifications.meter.moveBulk.success' },
  moveMetersBulkFailed: { id: 'app.notifications.meter.moveBulk.failed' },
  setParentMetersBulkError: { id: 'app.notifications.meter.setParentBulk.error' },
  setParentMetersBulkSuccess: { id: 'app.notifications.meter.setParentBulk.success' },
  setParentMetersBulkFailed: { id: 'app.notifications.meter.setParentBulk.failed' },
  setPlacementMetersBulkError: { id: 'app.notifications.meter.setPlacementBulk.error' },
  setPlacementMetersBulkSuccess: { id: 'app.notifications.meter.setPlacementBulk.success' },
  setPlacementMetersBulkFailed: { id: 'app.notifications.meter.setPlacementBulk.failed' },
  reportMeterFaultError: { id: 'app.notifications.meter.reportFault.error' },
  reportMeterFaultSuccess: { id: 'app.notifications.meter.reportFault.success' },
  replaceMeterError: { id: 'app.notifications.meter.replace.error' },
  replaceMeterSuccess: { id: 'app.notifications.meter.replace.success' },

  // Meter register
  createMeterRegisterError: { id: 'app.notifications.meterRegister.create.error' },
  createMeterRegisterSuccess: { id: 'app.notifications.meterRegister.create.success' },
  updateMeterRegisterError: { id: 'app.notifications.meterRegister.update.error' },
  updateMeterRegisterSuccess: { id: 'app.notifications.meterRegister.update.success' },
  deleteMeterRegisterError: { id: 'app.notifications.meterRegister.delete.error' },
  deleteMeterRegisterSuccess: { id: 'app.notifications.meterRegister.delete.success' },

  // Meter revision
  editRevisionSuccess: { id: 'app.notifications.meterRevision.update.success' },
  editRevisionError: { id: 'app.notifications.meterRevision.update.error' },
  deleteRevisionSuccess: { id: 'app.notifications.meterRevision.delete.success' },
  deleteRevisionError: { id: 'app.notifications.meterRevision.delete.error' },

  // Supply point revision
  createSupplyPointRevisionSuccess: { id: 'app.notifications.supplyPointRevision.create.success' },
  createSupplyPointRevisionError: { id: 'app.notifications.supplyPointRevision.create.error' },
  editSupplyPointRevisionSuccess: { id: 'app.notifications.supplyPointRevision.update.success' },
  editSupplyPointRevisionError: { id: 'app.notifications.supplyPointRevision.update.error' },

  // Favourite
  createFavouriteSuccess: { id: 'app.notifications.favourite.create.success' },
  createFavouriteError: { id: 'app.notifications.favourite.create.error' },
  updateFavouriteSuccess: { id: 'app.notifications.favourite.update.success' },
  updateFavouriteError: { id: 'app.notifications.favourite.update.error' },
  deleteFavouriteSuccess: { id: 'app.notifications.favourite.delete.success' },
  deleteFavouriteError: { id: 'app.notifications.favourite.delete.error' },

  // Tenant
  createTenantSuccess: { id: 'app.notifications.tenant.create.success' },
  createTenantError: { id: 'app.notifications.tenant.create.error' },
  updateTenantSuccess: { id: 'app.notifications.tenant.update.success' },
  updateTenantError: { id: 'app.notifications.tenant.update.error' },
  deleteTenantSuccess: { id: 'app.notifications.tenant.delete.success' },
  deleteTenantError: { id: 'app.notifications.tenant.delete.error' },

  // Billing
  calculateBillingSuccess: { id: 'app.notifications.billing.calculate.success' },
  calculateBillingError: { id: 'app.notifications.billing.calculate.error' },
  deleteBillingSuccess: { id: 'app.notifications.billing.delete.success' },
  deleteBillingError: { id: 'app.notifications.billing.delete.error' },
  previewBillingError: { id: 'app.notifications.billing.preview.error' },

  // Lease
  createLeaseSuccess: { id: 'app.notifications.lease.create.success' },
  createLeaseError: { id: 'app.notifications.lease.create.error' },
  updateLeaseSuccess: { id: 'app.notifications.lease.update.success' },
  updateLeaseError: { id: 'app.notifications.lease.update.error' },
  leasePeriodOverlap: { id: 'app.notifications.lease.periodOverlap' },
  // Leases
  createLeasesSuccess: { id: 'app.notifications.leases.create.success' },
  createLeasesError: { id: 'app.notifications.leases.create.error' },

  // LeaseUnit
  createLeaseUnitSuccess: { id: 'app.notifications.leaseUnit.create.success' },
  createLeaseUnitError: { id: 'app.notifications.leaseUnit.create.error' },
  updateLeaseUnitSuccess: { id: 'app.notifications.leaseUnit.update.success' },
  updateLeaseUnitError: { id: 'app.notifications.leaseUnit.update.error' },
  deleteLeaseUnitSuccess: { id: 'app.notifications.leaseUnit.delete.success' },
  deleteLeaseUnitError: { id: 'app.notifications.leaseUnit.delete.error' },

  // FloorPlan
  createFloorPlanSuccess: { id: 'app.notifications.floorPlan.create.success' },
  createFloorPlanError: { id: 'app.notifications.floorPlan.create.error' },
  updateFloorPlanSuccess: { id: 'app.notifications.floorPlan.update.success' },
  updateFloorPlanError: { id: 'app.notifications.floorPlan.update.error' },
  deleteFloorPlanSuccess: { id: 'app.notifications.floorPlan.delete.success' },
  deleteFloorPlanError: { id: 'app.notifications.floorPlan.delete.error' },
  createBillingSettingsSuccess: { id: 'app.notifications.billingSetting.create.success' },
  createBillingSettingsError: { id: 'app.notifications.billingSetting.create.error' },
  updateBillingSettingsSuccess: { id: 'app.notifications.billingSetting.update.success' },
  updateBillingSettingsError: { id: 'app.notifications.billingSetting.update.error' },
  deleteBillingSettingsSuccess: { id: 'app.notifications.billingSetting.delete.success' },
  deleteBillingSettingsError: { id: 'app.notifications.billingSetting.delete.error' },

  // Support - Bug Report
  createBugReportSuccess: { id: 'app.notifications.support.create.success' },

  // Support - Ask New Meter Model
  askNewMeterModelSuccess: { id: 'app.notifications.support.create.success' },
});

export const getDynamicErrorTranslation = (suffix: string) => ({
  id: `app.dynamic.notifications.${suffix}`,
});
